import React, { useState } from "react";
import "./Affiliates.css";

const Affiliates = ({ formType }) => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
    file: null,
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleFileChange = (e) => {
    setFormData({ ...formData, file: e.target.files[0] });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Form submitted:", formData);
    alert("Form submitted successfully!");
  };

  return (
    <div className="contact-form-container">
      <h2>{formType === "contact" ? "Contact Us" : "Affiliates and Partnerships"}</h2>
      <p>
        {formType === "contact"
          ? "Fill out the form for support, inquiries, or complaints."
          : "Interested in partnerships, proposals, or affiliate marketing? Fill out the form below."}
      </p>

      <form onSubmit={handleSubmit}>
        <label>Name</label>
        <input
          type="text"
          name="name"
          value={formData.name}
          onChange={handleChange}
          required
        />

        <label>Email</label>
        <input
          type="email"
          name="email"
          value={formData.email}
          onChange={handleChange}
          required
        />

        <label>Phone</label>
        <input
          type="tel"
          name="phone"
          className="phone-input"
          value={formData.phone}
          onChange={handleChange}
          required
        />

        <label>Message</label>
        <textarea
          name="message"
          value={formData.message}
          onChange={handleChange}
          rows="5"
          className="message-input"
          required
        ></textarea>

        <label>Attach Files</label>
        <input type="file" name="file" onChange={handleFileChange} />

        <button type="submit">Send</button>
      </form>
    </div>
  );
};

export default Affiliates;
